// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"styles_inputWrapper__uxsod","error":"styles_error__kw6Ry"};